// Copyright The OpenTelemetry Authors
// SPDX-License-Identifier: Apache-2.0

import { CypressFields } from '../../utils/Cypress';
import * as S from './ErrorState.styled';

interface IProps {
  title: string;
  message: string;
  onRetry: () => void;
}

const ErrorState = ({ title, message, onRetry }: IProps) => {
  return (
    <S.ErrorState role="alert" data-cy={CypressFields.ErrorState}>
      <S.Title>{title}</S.Title>
      <S.Message>{message}</S.Message>
      <S.RetryButton $type="secondary" onClick={onRetry}>
        Try again
      </S.RetryButton>
    </S.ErrorState>
  );
};

export default ErrorState;
